export enum TransportMode {
  ROAD = "R",
  TRAIN = "F",
  BOAT = "N",
}
